import { render, staticRenderFns } from "./versionLog.vue?vue&type=template&id=22c53371&scoped=true&"
import script from "./versionLog.vue?vue&type=script&lang=js&"
export * from "./versionLog.vue?vue&type=script&lang=js&"
import style0 from "./versionLog.vue?vue&type=style&index=0&lang=stylus&"
import style1 from "./versionLog.vue?vue&type=style&index=1&id=22c53371&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22c53371",
  null
  
)

export default component.exports